import { injectable } from 'tsyringe';
import {
  IOWLauncherEventsDelegate,
  OWGamesEventsDelegate,
  OWLauncherEvents,
} from '../../odk-ts';
import {
  IOWGameEventsListener,
  IOWGamesEventsDelegate,
} from 'app-core/src/interfaces/ow-wrappers/ow-game-events-listener-wrapper.interface';
import { LoggerService } from 'app-core/src/services/logger.service';
import { Application } from 'app-core/src/models/application.model';

export const kDITGameEventsListener = 'ow-game-events-listener-service';

// -----------------------------------------------------------------------------
@injectable()
export class OwGameEventsWrapper
  implements
    OWGamesEventsDelegate,
    IOWLauncherEventsDelegate,
    IOWGameEventsListener
{
  private readonly logger = LoggerService.getCategory('OwGameEventsWrapper');
  private launcherEventsService: OWLauncherEvents;
  private gameTriggerApps: Application[] = [];
  private requiresLep = false;
  private listener: IOWGamesEventsDelegate;

  // ---------------------------------------------------------------------------
  public async start(
    gameTriggerApps: Application[],
    listener: IOWGamesEventsDelegate,
  ): Promise<void> {
    this.listener = listener;
    const requiredFeatures = this.mergeRequiredFeatures(gameTriggerApps);
    if (!requiredFeatures?.length) {
      return;
    }

    this.gameTriggerApps = gameTriggerApps;

    this.requiresLep = this.gameTriggerApps.some((app) => {
      return app.gameEventTrigger.eventSource === 'LEP';
    });

    if (!this.requiresLep) {
      return;
    }

    this.launcherEventsService = new OWLauncherEvents(this);
    await this.launcherEventsService.start();
  }

  // ---------------------------------------------------------------------------
  public stop() {
    this.launcherEventsService?.stop();
    this.launcherEventsService = null;
    this.gameTriggerApps = [];
  }

  // ---------------------------------------------------------------------------
  private mergeRequiredFeatures(gameTriggerApps: Application[]) {
    const featuresSet = new Set<string>();
    for (const app of gameTriggerApps) {
      const trigger = app.gameEventTrigger;
      if (!trigger || !Array.isArray(trigger.requiredFeatures)) {
        continue;
      }

      for (const feature of trigger.requiredFeatures) {
        featuresSet.add(feature);
      }
    }

    return Array.from(featuresSet);
  }

  // ---------------------------------------------------------------------------
  // OWGamesEventsDelegate
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  onInfoUpdates(info: any) {
    this.listener?.onInfoUpdates(info);
  }

  // ---------------------------------------------------------------------------
  onNewEvents(e: any) {
    this.listener?.onNewEvents(e);
  }

  // ---------------------------------------------------------------------------
  // IOWLauncherEventsDelegate
  // ---------------------------------------------------------------------------

  onLauncherStarted(info: any) {
    // this.logger.info('Launcher started:', JSON.stringify(info));
    //
  }

  onLauncherStopped(info: any) {
    // this.logger.info('Launcher stopped:', JSON.stringify(info));
  }
}
